import { Link } from "react-router-dom";

const footerLinks = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "影视资讯", to: "/news" },
  { label: "关于我们", to: "/about" },
];

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-16 bg-primary-900 text-background-100">
      <div className="mx-auto grid max-w-[1280px] grid-cols-1 gap-8 px-4 py-12 md:grid-cols-3 md:px-6 md:py-14">
        <div>
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-50">
              <i className="ri-film-line text-xl" aria-hidden="true"></i>
            </span>
            <span className="font-heading text-lg font-extrabold text-background-50">麻豆精品</span>
          </div>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-primary-100">
            麻豆精品致力于为电影与电视剧爱好者提供最新影视内容索引与专业影视资讯，让每一次观影选择都更简单、更值得。
          </p>
        </div>

        <div>
          <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-accent-300">
            站内导航
          </h4>
          <ul className="mt-4 grid grid-cols-2 gap-2.5">
            {footerLinks.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="text-sm text-primary-100 transition-colors hover:text-accent-300"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-accent-300">
            联系我们
          </h4>
          <ul className="mt-4 space-y-3 text-sm text-primary-100">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-accent-300" aria-hidden="true"></i>
              contact@modou-jingpin.com
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-wechat-line text-accent-300" aria-hidden="true"></i>
              微信公众号：麻豆精品影视
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line text-accent-300" aria-hidden="true"></i>
              内容每日更新 · 全年无休
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="mx-auto flex max-w-[1280px] flex-col gap-2 px-4 py-5 text-xs text-primary-200 md:flex-row md:items-center md:justify-between md:px-6">
          <p>© {year} 麻豆精品 · 本站为影视内容演示站点，所有影片与资讯均为演示数据。</p>
          <p>仅供学习与演示使用，请支持正版影视作品。</p>
        </div>
      </div>
    </footer>
  );
}